import { Injectable, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { filter, switchMap, take, tap, catchError, of, combineLatest } from 'rxjs';
import { ApiService, EnsureUserRequest } from './api.service';

/**
 * Calls `POST /api/v1/users/ensure` once per app load after authentication.
 */
@Injectable({ providedIn: 'root' })
export class UserEnsureService {
  private auth = inject(AuthService);
  private api = inject(ApiService);

  private started = false;
  private ensured = false;

  start(): void {
    if (this.started) return;
    this.started = true;

    combineLatest([this.auth.isAuthenticated$, this.auth.user$])
      .pipe(
        filter(([isAuthed, user]) => !!isAuthed && !!user),
        take(1),
        filter(() => !this.ensured),
        tap(() => (this.ensured = true)),
        switchMap(([, user]) => {
          const u: any = user;
          const payload: EnsureUserRequest = {
            sub: u?.sub,
            email: u?.email,
            email_verified: u?.email_verified,
            name: u?.name,
            picture: u?.picture,
          };
          return this.api.ensureUser(payload);
        }),
        catchError((e) => {
          // Don't block app if ensure fails; log and continue.
          console.error('users/ensure failed:', e);
          return of(null);
        }),
      )
      .subscribe();
  }
}

